export default __webpack_public_path__ + "static/media/recent_activity_5.e02ba648.jpg";